import React from 'react';
import { DetailsList, ShimmeredDetailsList } from '@fluentui/react';
import { BaseCampaignDetailsList } from './base-campaign-details-list';


export const CampaignDetailsList = props => <BaseCampaignDetailsList Renderer={DetailsList} {...props} />;

export const CampaignShimmeredDetailsList = props => <BaseCampaignDetailsList Renderer={ShimmeredDetailsList} {...props} />;

export { CampaignDetailsRow } from './campaign-details-row';

export { Pagination } from './pagination';

export { ParentColumnPlacement, DefaultSortDirection } from './utils/constants';

export { CommonColumn } from './utils/common-columns';
